<kpd-alert type="error" *ngIf="!!error" icon="error-standard">
  {{ error }}
</kpd-alert>
<form [formGroup]="form" novalidate>
  <div class="form__control form__password flex-row" [ngStyle]="{ display: localUser ? 'none' : 'flex' }">
    <label>{{ 'Old password' | translate }}:</label>
    <div class="form__input">
      <input
        type="password"
        class="form__control"
        formControlName="oldPassword"
        autocomplete="off"
        [ngClass]="{ 'form__input--invalid': hasError('oldPassword') }"
        [attr.disabled]="disabled ? '' : null"
      />
      <kpd-input-error [control]="form.controls.oldPassword"></kpd-input-error>
    </div>
  </div>
  <br />
  <div class="form__control form__password flex-row">
    <label>{{ 'New password' | translate }}:</label>
    <div class="form__input">
      <input
        type="password"
        class="form__control"
        formControlName="password"
        autocomplete="off"
        [ngClass]="{ 'form__input--invalid': hasError('password') }"
        [attr.disabled]="disabled ? '' : null"
      />
      <kpd-input-error [control]="form.controls.password"></kpd-input-error>
    </div>
  </div>
  <div class="form__control form__password flex-row">
    <label>{{ 'Confirm' | translate }}:</label>
    <div class="form__input">
      <input
        type="password"
        class="form__control"
        formControlName="confirmPassword"
        autocomplete="off"
        (input)="onConfirmPasswordInput()"
        [ngClass]="{ 'form__input--invalid': hasError('confirmPassword') }"
        [attr.disabled]="disabled ? '' : null"
      />
      <kpd-input-error [control]="form.controls.confirmPassword"></kpd-input-error>
    </div>
  </div>
</form>
